export const WithdrawType = {
  ABCCrypto: "abc crypto",
  ABC: "abc",
  ABCNONUTRTWO: "abc non utr 2",
  ABCUTR: "abc utr",
  ABCUTRTWO: "abc utr two",
  ABCUTRTHREE: "abc utr three",
  ABCUTRFOUR: "abc utr four",
  ABCUTRFIVE: "abc utr five",
  ABCBANKTRANSFER: "abc bank transfer",
  GatewayHub: "gatewayhub",
  PayzEasy: "payzeasy",
};
